import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { sendNewUserData } from "../redux/asyncThunk/userActions";
import { AUTH_FIELD_SX } from "../pages/AuthLayout";
import PasswordField from "./PasswordField";
import {
  REQUIRED_FIELDS_MESSAGE,
  validateNewPasswordForm,
  sanitizePasswordInput,
} from "../utils/authForms";

export default function NewPasswordForm({ token }) {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.user.messages);
  const [newpass, setNewpass] = useState({ pass: "", confirmPass: "" });
  const [fieldErrors, setFieldErrors] = useState({});
  const [message, setMessage] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const latest = messages[messages.length - 1];
    if (latest?.message) {
      setMessage(latest);
    }
  }, [messages]);

  const changePasswordData = (event) => {
    const { id, value } = event.target;
    setMessage({ type: "", message: "" });
    setFieldErrors((prev) => {
      const next = { ...prev };
      delete next[id];
      if (id === "pass" || id === "confirmPass") {
        delete next.pass;
        delete next.confirmPass;
      }
      return next;
    });
    setNewpass((prev) => ({
      ...prev,
      [id]: sanitizePasswordInput(value),
    }));
  };

  const handleSaveNewPasswordButton = async (event) => {
    event?.preventDefault();
    const errors = validateNewPasswordForm(newpass);

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      const hasEmpty = !newpass.pass || !newpass.confirmPass;
      setMessage({
        type: "error",
        message: hasEmpty ? REQUIRED_FIELDS_MESSAGE : Object.values(errors)[0],
      });
      return;
    }

    setFieldErrors({});
    setMessage({ type: "", message: "" });
    setIsSubmitting(true);

    try {
      await dispatch(
        sendNewUserData({ token, pass: newpass.pass })
      ).unwrap();
    } catch (err) {
      setMessage({
        type: "error",
        message:
          err?.message || "Не удалось сохранить пароль. Попробуйте позже.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSaveNewPasswordButton} noValidate>
      <div className="auth-card__body">
        <PasswordField
          id="pass"
          label="Новый пароль"
          variant="outlined"
          required
          autoComplete="new-password"
          value={newpass.pass}
          sx={AUTH_FIELD_SX}
          onChange={changePasswordData}
          error={Boolean(fieldErrors.pass)}
          helperText={fieldErrors.pass}
        />
        <PasswordField
          id="confirmPass"
          label="Повторите пароль"
          variant="outlined"
          required
          autoComplete="new-password"
          value={newpass.confirmPass}
          sx={AUTH_FIELD_SX}
          onChange={changePasswordData}
          error={Boolean(fieldErrors.confirmPass)}
          helperText={fieldErrors.confirmPass}
        />

        {message?.message ? (
          <div
            className={`auth-form__message auth-form__message--${
              message.type === "error" ? "error" : "success"
            }`}
            role="alert"
          >
            {message.message}
          </div>
        ) : null}

        {!message?.success && (
          <Button
            type="submit"
            variant="contained"
            className="auth-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Сохранение…" : "Сохранить пароль"}
          </Button>
        )}
      </div>
    </form>
  );
}
